export const transformTitle = (title: string) => {
  if (!title) {
    return ""
  }

  return title
    .split(" ")
    .map((part: string) => ((part || " ")[0]).toUpperCase())
    .join("")
    .trim()
}
